import { axiosAuthInstance } from "../utils/getSubdomain"

export type StaffDashboardStat = {
  key: string
  total: number
  addedThisMonth: number
  changePercent: number | null
}

export type StaffDashboardTeacher = {
  id: string
  name: string
  profilePhoto?: string | null
}

export type StaffDashboardSubject = {
  id: string
  title: string
  questionCount: number
  image?: string | null
}

export type StaffDashboardTemplate = {
  id: string
  name: string
  thumbnail?: string | null
  subjectTitle?: string
  usageCount?: number
}

export type StaffDashboardActivity = {
  type: string
  title: string
  description: string
  createdAt?: string | null
}

export type StaffDashboardData = {
  stats: StaffDashboardStat[]
  topSubjects: StaffDashboardSubject[]
  topTemplates: StaffDashboardTemplate[]
  activity: StaffDashboardActivity[]
  topTeachers?: StaffDashboardTeacher[]
}

export const getStaffDashboard = () =>
  axiosAuthInstance.get<{
    success: boolean
    message: string
    data: StaffDashboardData
  }>("/dashboard/")
